import Image from 'next/image'
import Link from 'next/link'
import { getHomepageMediaAlt, getHomepageMediaUrl, type HomepageContent } from './PayloadHomepageHero'

export default function PayloadPromoBanner({ content }: { content: HomepageContent }) {
  const promo = content.promoSection
  const desktopImage = getHomepageMediaUrl(promo?.desktopImage, 'original')
  const mobileImage = getHomepageMediaUrl(promo?.mobileImage, 'original')

  if (!desktopImage || !mobileImage) return null

  const label = promo?.linkLabel || 'Scopri la promozione'
  const desktop = (
    <div className="relative aspect-[1440/503] w-full overflow-hidden">
      <Image src={desktopImage} alt={getHomepageMediaAlt(promo?.desktopImage)} fill unoptimized sizes="100vw" className="object-cover" />
    </div>
  )
  const mobile = (
    <div className="relative aspect-[350/438] w-full overflow-hidden rounded-[18px]">
        <Image src={mobileImage} alt={getHomepageMediaAlt(promo?.mobileImage)} fill unoptimized sizes="(max-width: 767px) calc(100vw - 40px), 0px" className="object-cover" />
    </div>
  )

  return (
    <section className="bg-white" aria-label="Promozione">
      <div className="hidden w-full md:block">
        {promo?.href ? <Link href={promo.href} aria-label={label} className="block">{desktop}</Link> : desktop}
      </div>
      <div className="homepage-content-container md:hidden">
        {promo?.href ? <Link href={promo.href} aria-label={label} className="block">{mobile}</Link> : mobile}
      </div>
    </section>
  )
}
